import React, { useEffect } from "react";
import "./styles.less";

import { DocBlock } from "../components/DocBlock";
import { DocCode } from "../components/DocCode";
import { DocImg } from "../components/DocImg";

export const M2mPlayground = () => {
  useEffect(() => {
    tocbot.init({
      // Where to render the table of contents.
      tocSelector: ".m2m-toc",
      // Where to grab the headings to build the table of contents.
      contentSelector: ".m2m-toc-content",
      // Which headings to grab inside of the contentSelector element.
      headingSelector: "h1, h2, h3",
      // For headings inside relative or absolute positioned containers within content.
      hasInnerContainers: true,
      positionFixedSelector: ".m2m-toc",
      linkClass: "toc-link",
    });
  }, []);
  return (
    <div className="m2m-plauground-warp">
      <div className="m2m-plauground-inner">
        <div className="m2m-toc-content toc-content-left">
          <DocBlock title="项目简介" keyId="m2m-1">
            <div className="descript">
              <p>
                本项目前端使用 Vue ，后端使用 nodejs 开发。通过在 Authing
                控制台新建应用，并且新建编程账号，同时给编程账号分配接口资源，实现对编程账号的权限控制，实现机器间授权。
              </p>
              <p>引用的开源项目地址：</p>
              <p>
                Github：
                <a href="https://github.com/Authing/Playground-M2M">
                  https://github.com/Authing/Playground-M2M
                </a>
              </p>
              <p>
                项目前后端分离，前端采用 Vue3 ，后端采用
                nodejs，均是具有代表性的技术栈。
              </p>
              <p>
                项目说明文档中已经详细的阐述了如何部署到本地，此处仅补充说明:
              </p>
              <p>1. 分别启动前后端服务</p>
              <p>
                项目仅作示例展示用，接下来将具体介绍如何接入 Authing
                服务，有多种方式，本文侧重在于介绍通过在 Authing 控制台配置
                AK/SK,并且通过调用 API 的方式，进行 M2M 授权。
              </p>
            </div>
          </DocBlock>
          <DocBlock title="预备知识" keyId="m2m-2">
            <div className="descript">
              <p>
                如果你还没有用过
                Authing，可以点击这里查看如何创建一个自己的应用。
              </p>
              <p>
                对 Authing 的任何名词/概念有疑问：
                <a href="https://docs.authing.co/v2/concepts/">
                  https://docs.authing.co/v2/concepts/
                </a>
              </p>
              <p>
                接下来，假设你已经对 Authing 有初步了解，且在 Authing
                控制台创建了一个自己的应用。
              </p>
            </div>
          </DocBlock>
          <DocBlock title="控制台配置" keyId="m2m-3">
            <div className="descript">
              <div className="second-title">1. 编程访问账号</div>
              <DocImg
                title="新建应用,应用名称为开放平台，认证地址为 http://open-playground.authing.cn"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-01.png"
              />
              <DocImg
                title="进入 开放平台 应用的 访问授权 tab 页面。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-02.png"
              />
              <DocImg
                title="页面滚动到最低端的编程访问界面。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-03.png"
              />
              <DocImg
                title="点击添加按钮，添加 AK/SK 编程账号"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-04.png"
              />
              <p>
                在备注框里面输入备注信息：M2M 授权 Demo
                账号，点击确定完成编程账号的创建。
              </p>
              <p>
                在开放平台下，你可以通过注册不同的编程访问账号，分配给开放平台下的应用。开放平台下的应用可以设置不同的编程访问账号，为其设置不同的资源访问权限，达到限制资源访问授权的效果。
              </p>
              <div className="second-title">2. 添加资源</div>
              <p>
                在完成编程访问账号的创建后，我们就可以将开放平台下的 api
                创建为资源，并且通过将资源分配给不同的编程访问账号，以达到给不同的应用授权的目的。
              </p>
              <p>
                接下来我们分别添加 4 个开放 API 资源，分别是人脸识别 API
                资源，性别识别 API 资源、物体识别 API 资源、动作识别 API 资源。
              </p>
              <p>添加完成后，需要将 API 资源的访问权限授权给编程访问账号。</p>
              <DocImg
                title="在控制台主界面的左侧，点击权限管理，进入权限管理页面。在权限分组列表，选择 开放平台 的全选分组。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-05.png"
              />
              <DocImg
                title="点击创建资源按钮"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-06.png"
              />
              <DocImg
                title="在创建资源界面，输入资源名称，资源 Code ，资源类型选择 API 。并且添加资源操作。具体示例如下图。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-07.png"
              />
              <DocImg
                title="按照上述操作，分别创建性别识别的资源。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-08.png"
              />
              <DocImg
                title="创建物体识别接口的资源。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-09.png"
              />
              <DocImg
                title="创建动作识别 API 资源。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-10.png"
              />
              <div className="second-title">3. 授权资源给编程账号</div>
              <p>
                在权限管理的授权管理页面，可以将刚创建的 API
                资源授权给编程访问账号。具体流程如下。
              </p>
              <DocImg
                title="在授权管理界面，点击授权按钮。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-11.png"
              />
              <DocImg
                title="在弹出的授权窗口，被授权主体类型选择 - 编程访问账号。在被授权主体输入框内，选中创建的编程访问账号，在授权规则选中，资源列表选择人脸识别。具体配置如下图："
                src="//files.authing.co/authing-website/doc-img/playground-m2m-12.png"
              />
              <DocImg
                title="依次新建授权性别 API 资源授权、物体 API 资源授权、动作 API 资源授权。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-13.png"
              />
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-m2m-14.png" />
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-m2m-15.png" />
              <p>这样，控制台相关的资源配置就完成了。</p>
            </div>
          </DocBlock>
          <DocBlock title="后端配置" keyId="m2m-4">
            <div className="descript">
              <p>github:</p>
              <p>
                将代码下载完成后，进入项目的 service 目录。通过 Visual Code
                打开文件夹。
              </p>
              <DocImg
                title="将应用的相关配置，例如应用 ID、应用密钥、应用认证地址、应用回调地址填写到 config 文件夹的 dev.js 文件里。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-16.png"
              />
              <DocImg
                title="后台提供了四个接口，分别是人脸识别、性别识别、物体识别、动作识别。在接口中对 http 的请求头的 Authorization 字段进行了判断。如果 ACCESSTOKEN 包含了接口所需要的 scope ，那么此 http 的请求就有权限访问接口。反之则无权限。相关接口的权限判断逻辑如下："
                src="//files.authing.co/authing-website/doc-img/playground-m2m-17.png"
              />
              <DocCode
                title="配置填写完成后，在终端运行命令："
                code={`npm install`}
              />
              <DocCode
                title="完成依赖包的安装后，运行命令："
                code={`npm run dev`}
              />
              <p>既可以开启监听服务。</p>
            </div>
          </DocBlock>
          <DocBlock title="前端配置" keyId="m2m-5">
            <div className="descript">
              <p>github:</p>

              <DocImg
                title="将代码下载完成后，我们在 Visual Code 中打开项目。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-18.png"
              />
              <p>
                在项目代码中，我们初步实现了一个 M2M
                的获取授权码，以及通过授权码请求资源接口获取数据的相关逻辑。
              </p>
              <p>
                在前端项目中，只需要将相关的应用配置填写好，既可以与后端进行 M2M
                的授权。
              </p>
              <p>
                打开根目录的 .env 文件夹。输入编程访问账号的
                AppKey、AppSecret，以及应用的认证地址、回调地址、应用 ID。
              </p>

              <DocCode title="接下来运行命令" code={`npm install `} />
              <DocCode
                title="完成依赖包的安装后，输入命令 "
                code={`npm run dev`}
              />
              <p>运行前端程序</p>
            </div>
          </DocBlock>
          <DocBlock title="运行程序" keyId="m2m-6">
            <div className="descript">
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-m2m-19.png" />
              <p>输入用户名和密码，进入到主界面。</p>
              <p>在主界面列除了当前配置的应用的编程访问账号以及账号的密钥。</p>
              <p>
                通过在资源名中输入资源的操作，以便获取到访问资源所需要的
                ACCESSTOKEN。
              </p>
              <p>
                例如我们要访问人脸识别接口，那么我们先在资源操作框内输入
                FACE:call，然后点击获取 Token 按钮，即可获取到 ACCESSTOKEN.
              </p>
              <DocImg src="//files.authing.co/authing-website/doc-img/playground-m2m-20.png" />
              <p>
                随后，通过点击 人脸识别 API 按钮，就可以访问后台的 人脸识别
                的接口。
              </p>
              <DocImg
                title="在访问后台接口时，需要将 ACCESSTOKEN 携带进 HTTP 请求头的 Authorization 字段。这样后台接口才能对 ACCESSTOKEN 进行解析和权限判断。"
                src="//files.authing.co/authing-website/doc-img/playground-m2m-21.png"
              />
              <p>
                如果 ACCESSTOKEN 具有权限，那么后台就会返回一个字符串 FACE。
              </p>
            </div>
          </DocBlock>
        </div>
        <div className="toc-rigth">
          <div className="m2m-toc"></div>
        </div>
      </div>
      <div style={{ clear: "both" }}></div>
    </div>
  );
};
